export const types = {
	login: '[Auth] Login',
	logout: '[Auth] Logout',

	uiSetError: '[UI] Set error',
	uiRemoveError: '[UI] Remove error',

	uiStartLoading: '[UI] Start loading',
	uiFinishLoading: '[UI] Finish loading',

	notesAddNew: '[Notes] New note',
	notesActive: '[Notes] Set active note',
	notesLoad: '[Notes] Load note',
	notesUpdated: '[Notes] Updated note save',
	notesFileUrl: '[Notes] Updated image url',
	notesDelete: '[Notes] Delete note',
	notesLogoutCleaning: '[Notes] Logout Cleaning',
	
};
